import { lazy } from "react";
import ViewStudentNotification from "@repo/design-system/components/viewStudentNotification/ViewStudentNotification.jsx";

const Dashboard = lazy(() => import("../pages/Dashboard/Dashboard"));
const Profile = lazy(() => import("../pages/profile/Profile"));
const Settings = lazy(() => import("@gyandiksha/profile/components/StudentSettings"));
const EditProfile = lazy(() => import("../pages/editProfile/EditProfile"));
const Attendance = lazy(() => import("../pages/attendance/Attendance"));
const ViewStudentNotificationPage = () => (
    <ViewStudentNotification />
);

// Teacher / HOD Student Attendance
const StudentAttendanceDashboard = lazy(() => import("../pages/teacherHodAttendance/dashboard/StudentAttendanceDashboard"));
const StudentAttendance = lazy(() => import("../pages/teacherHodAttendance/studentAttendance/StudentAttendance"));
const StudentAttendanceReport = lazy(() => import("../pages/teacherHodAttendance/studentAttendanceReport/StudentAttendanceReport"));

// Student Attendance Configuration
const StudentWeekOffConfiguration = lazy(() => import("../pages/studentAttendanceConfiguration/studentWeekOffConfiguration/StudentWeekOffConfiguration"));
const StudentHolidayConfiguration = lazy(() => import("../pages/studentAttendanceConfiguration/studentHolidayConfiguration/StudentHolidayConfiguration"));

const ComponentNavigation = [
    {
        id: "dashboard",
        path: "/dashboard",
        exact: true,
        title: "",
        component: Dashboard,
        hasParams: false,
        text: "Student Attendance Dashboard",
    },
    {
        id: "attendance",
        path: "/attendance-history",
        exact: true,
        title: "",
        component: Attendance,
        hasParams: false,
        text: "My Attendance History",
    },
    {
        id: "profile",
        path: "/profile",
        exact: true,
        title: "",
        component: Profile,
        hasParams: false,
        text: "My Profile",
    },
    {
        id: "edit-profile",
        path: "/edit-profile",
        exact: true,
        title: "",
        component: EditProfile,
        hasParams: false,
        text: "Edit Profile",
    },
    {
        id: "settings",
        path: "/settings",
        exact: true,
        title: "",
        component: Settings,
        hasParams: false,
        text: "Settings",
    },
    {
        id: "view-student-notification",
        path: "/view-student-notification",
        exact: true,
        title: "",
        component: ViewStudentNotificationPage,
        hasParams: false,
        text: "View Student Notifications",
    },

    // Teacher / HOD Student Attendance
    {
        id: "studentAttendanceDashboard",
        path: "/student-management/dashboard",
        exact: true,
        title: "Student Attendance Dashboard",
        component: StudentAttendanceDashboard,
        hasParams: false,
        text: "Dashboard",
    },
    {
        id: "studentAttendance",
        path: "/student-management/attendance",
        exact: true,
        title: "",
        component: StudentAttendance,
        hasParams: false,
        text: "Student Attendance History",
    },
    {
        id: "studentAttendanceReport",
        path: "/student-management/report",
        exact: true,
        title: "",
        component: StudentAttendanceReport,
        hasParams: false,
        text: "Student Attendance Report",
    },

    // Student Attendance Configuration
    {
        id: "studentWeekOffConfiguration",
        path: "/student-week-off-configuration",
        exact: true,
        title: "",
        component: StudentWeekOffConfiguration,
        hasParams: false,
        text: "Student Week-off Configuration",
    },
    {
        id: "studentHolidayConfiguration",
        path: "/student-holiday-configuration",
        exact: true,
        title: "",
        component: StudentHolidayConfiguration,
        hasParams: false,
        text: "Student Holiday Configuration",
    },
];

export default ComponentNavigation;
